import { render } from "./AssignmentsList.vue?vue&type=template&id=6bef33ec&scoped=true"
import script from "./AssignmentsList.vue?vue&type=script&lang=js"
export * from "./AssignmentsList.vue?vue&type=script&lang=js"

import "./AssignmentsList.vue?vue&type=style&index=0&id=6bef33ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bef33ec"]])

export default __exports__